import React, { Fragment } from "react"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import compose from "ramda/src/compose"
import { translate } from "react-i18next"
import _isNil from "lodash/isNil"

import GeneralProductInformation from "shared/components/GeneralProductInformation"
import WrapperSkeleton from "../../../src/components/WrapperSkeleton"
import EmptyState from "shared/components/EmptyState"
import Button from "shared/components/Button/Button"
import DefaultTitle from "shared/components/DefaultTitle"
import SummaryCard from "./components/SummaryCard"

import { useProductsOptions } from "../DetailingPosPreControle/utils/useProducts"
import { useDetailsProduct } from "../DetailingPosPreControle/utils/useDetailsProduct"
import { useBills } from "../../hooks/useBills"
import { useTrafficData } from "./utils/useTrafficData"

import styles from "./styles.css"

import EmptyStateIcon from "../../assets/svg/icon-ok.svg"
import IconError from "assets/svg/erro-desbloqueio.svg"
import InactiveProductsEmptyState from "shared/components/InactiveProductsEmptyState/index"

const DataQuota = ({
  t,
  useProductsOptions,
  useDetailsProduct,
  useBills,
  loading,
  documentNumber,
  traffic,
  useTrafficData,
  history
}) => {
  useBills()
  const [optionSelected, options, notFindProductsWithDetail, onChangeOption] =
    useProductsOptions()
  const { selected, productSelected } = optionSelected
  const detailProduct = useDetailsProduct(productSelected, documentNumber)
  const { value } = selected

  useTrafficData(productSelected)

  const inactiveProducts = JSON.parse(
    window.localStorage.getItem("inactiveProducts")
  )

  if (inactiveProducts) {
    return (
      <Fragment>
        <DefaultTitle>{t("MSG_0463")}</DefaultTitle>
        <InactiveProductsEmptyState />
      </Fragment>
    )
  }

  return (
    <Fragment>
      <DefaultTitle>Cota de dados</DefaultTitle>
      <WrapperSkeleton path="/automatic-debit" isChildrenReady={!loading}>
        {notFindProductsWithDetail ? (
          <EmptyState
            isContainer
            icon={EmptyStateIcon}
            title="Não existe nenhum produto de telefonia móvel contratado!"
            description="Entre em contato com o seu consultor para contratar o plano mais adequado para você."
          >
            <Button isLink url="/AreaClienteCorporativo" fontWeight="fw-5">
              {t("MSG_0232")}
            </Button>
          </EmptyState>
        ) : (
          <GeneralProductInformation
            hasSelectOption
            isDataQuota
            titleSelectOption="Selecione o número"
            details={detailProduct}
            options={options}
            onChangeOption={(e) => onChangeOption(e.target.value)}
            optionSelected={value}
          />
        )}

        <div className={styles.containerSummary}>
          {traffic.errors || _isNil(traffic.traffic) ? (
            <EmptyState
              icon={IconError}
              description="Ops! Não foi possível encontrar os dados! Tente novamente ou entre em contato com o nosso atendimento."
            />
          ) : (
            <SummaryCard
              cardItems={traffic.traffic.balanceDetails}
              t={t}
              productSelected={productSelected}
              history={history}
            />
          )}
        </div>
      </WrapperSkeleton>
    </Fragment>
  )
}

DataQuota.propTypes = {
  products: PropTypes.object,
  useProductsOptions: PropTypes.func,
  useDetailsProduct: PropTypes.func,
  useBills: PropTypes.func,
  useTrafficData: PropTypes.func,
  loading: PropTypes.bool,
  t: PropTypes.func,
  documentNumber: PropTypes.string,
  traffic: PropTypes.object,
  history: PropTypes.object
}
const mapStateToProps = ({
  customer,
  products,
  bills,
  invoices,
  customerOpenInvoices,
  traffic
}) => ({
  customer: customer.data,
  products,
  bills,
  documentNumber: customer.data.documentNumber,
  traffic,
  loading:
    bills.loading ||
    products.loading ||
    products.detail.loading ||
    invoices.loading ||
    customerOpenInvoices.loading ||
    traffic.loading
})

const enhance = compose(
  withRouter,
  translate(),
  connect(mapStateToProps, {
    useProductsOptions,
    useDetailsProduct,
    useBills,
    useTrafficData
  })
)

export default enhance(DataQuota)



// WEBPACK FOOTER //
// ./src/scenes/DataQuota/index.js